/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-21 14:47:46
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-09-30 16:33:58
 * @FilePath: \pit-bimwin-react-ui\src\components\PitModule\sectioning.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {
  FC,
  useState,
  // CSSProperties,
  // memo,
  // useCallback,
  // useRef,
  // useEffect,
} from 'react';
interface PitModuleInformationProps {}
const PitModuleInformation: FC<PitModuleInformationProps> = () => {
  let [meshNum] = useState(0);
  let [lineNum] = useState(0);
  let [nodeNum] = useState(0);
  return (
    <div className="pit-info">
      <div className="pit-info-list">
        <div>
          <span>构件数量：</span>
          <span className="pit-info-value">{nodeNum}</span>
        </div>
        <div>
          <span>三角面数量：</span>
          <span className="pit-info-value">
            {meshNum /*infoList.triangles*/}
          </span>
        </div>
        <div>
          <span>顶点数量：</span>
          <span className="pit-info-value">{0 /*infoList.points*/}</span>
        </div>
        <div>
          <span>线数量：</span>
          <span className="pit-info-value">{lineNum /*infoList.lines*/}</span>
        </div>
      </div>
      <div className="copyright">
        Copyright@
        <a href="https://bimwin.power-itech.cn/">power-itech.cn</a>
      </div>
    </div>
  );
};
export default PitModuleInformation;
